import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicActionService } from 'src/app/core/api/dynamic-action.service';
import { NavigationService } from 'src/app/core/api/navigation.service';
import { DynamicActionConfig } from 'src/app/shared/models/dynamic-action.model';
import { bottomActionsSchema } from './../../../core/schemas/navigation-schema';

@Component({
  selector: 'csi-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  public bottomActionsSchema = bottomActionsSchema;
  public sidebarActionsDisabled = false;
  constructor(
    public dynamicActionService: DynamicActionService,
    public navigationService: NavigationService
  ) {}

  public readonly translocoFileKey = 'general.';

  ngOnInit() {}
  ngOnDestroy(): void {}

  performAction(actionConfig: DynamicActionConfig | undefined, e?: Event) {
    if (this.sidebarActionsDisabled) {
      // Prevent duplicate actions being performed
      return;
    }
    this.sidebarActionsDisabled = true;
    setTimeout(() => {
      this.sidebarActionsDisabled = false;
    }, 1000);

    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (actionConfig) {
      this.dynamicActionService.performAction(actionConfig);
    }
  }
}
